// Libs
import classNames from 'classnames/bind';
import { Box, InputAdornment, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ChangeEvent, useEffect, useState } from 'react';
// Components, Layouts, Pages
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { TInputSearchStyleType } from '~/utils/type/common';
// Styles, images, icons
import styles from './BaseInputSearch.module.scss';
import { icons } from '~/assets';

type Props = {
  typeStyle?: TInputSearchStyleType;
  searchByContent?: string;
  placeholder?: string;
  borderRadius?: number | string;
  value?: string;
  width?: number | string;
  height?: number | string;
  onChange?: (searchValue: string) => void;
  onSearch?: (searchValue: string) => void;
};

const cx = classNames.bind(styles);

const BaseInputSearch = (props: Props) => {
  //#region Destructuring Props
  const {
    placeholder,
    height = 40,
    searchByContent,
    value,
    width,
    borderRadius,
    typeStyle = 'contained',
    onChange,
    onSearch,
  } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [searchValue, setSearchValue] = useState<string>(EMPTY_STRING);
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  useEffect(() => {
    setSearchValue(value || EMPTY_STRING);
  }, [value]);
  //#endregion Implement Hook

  //#region Handle Function
  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    setSearchValue(value);
    onChange && onChange(value.trim());
  };

  const handleSearch = () => {
    onSearch?.(searchValue.trim());
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };
  //#endregion Handle Function

  return (
    <Box component={'div'} id='baseInputSearchComponent' style={{ width, height }}>
      <TextField
        placeholder={
          placeholder ||
          (searchByContent
            ? t('common_search_by_placeholder', { by: searchByContent })
            : t('common_search_placeholder'))
        }
        sx={{ width, height, borderRadius }}
        value={searchValue}
        onChange={handleSearchChange}
        onKeyDown={handleKeyDown}
        onClick={(e) => e.stopPropagation()}
        slotProps={{
          input: {
            className: cx('searchInput', typeStyle),
            style: { width, height, borderRadius },
            startAdornment: (
              <InputAdornment position='start' className={cx('inputAdornment')}>
                <img src={icons.commonIconInputSearch} alt={cx(t('common/base'))} onClick={handleSearch} />
              </InputAdornment>
            ),
          },
        }}
      />
    </Box>
  );
};

export default BaseInputSearch;
